module.exports = __webpack_public_path__ + "img/logo-login.e6379b20.svg";